import { IonTitle } from "@ionic/react";
import OriginalChannelListHeader from "@wearesweet/sendbird-uikit-react/ChannelList/components/ChannelListHeader";
import { t } from "i18next";
import React from "react";
import { PageHeader } from "../../../components/PageHeader";
import { useViewport } from "../../../utils/useViewport";
import { ChannelFilter } from "./ChannelFilter";
import { CreateChannel } from "./CreateChannel";

/**
 * renderIconButton={() => (
 *       <CreateChannel />
 *     )
 */

export const ChannelListHeader = (props: void) => {
  const { isDesktop } = useViewport();

  return isDesktop ? (
    <OriginalChannelListHeader
      allowProfileEdit={false}
      renderTitle={() => {
        const header = t("chats").charAt(0).toUpperCase() + t("chats").slice(1);
        return isDesktop ? <IonTitle>{header}</IonTitle> : <PageHeader safeArea={false}>{header}</PageHeader>;
      }}
      renderIconButton={() => (
        <>
          <ChannelFilter />
          <CreateChannel />
        </>
      )}
    />
  ) : (
    <></>
  );
};
